import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import Banner from '../components/common/Banner';

const Login = () => {
  // userId & password state with error handling
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  // Authentication & navigation hooks
  const navigate = useNavigate();
  const auth = getAuth();

  // Handle form submission for login
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signInWithEmailAndPassword(auth, userId.toLocaleLowerCase() + "@varenyamatrimonial.com", password.toLocaleUpperCase());
      navigate('/dashboard');
    } catch (err) {
      setError("Invalid User Id or Password. Please try again.");
    }
  };

  return (
    <div>
      {/* Page Title */}
      <Banner title={"Member Login"} desc={"Login"} img={"images/bg/bg_1.jpg"} />

      {/* Login Form */}
      <section className="section about-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <div className="p-5 shadow rounded">
                <h4 className="mb-4">Member Login</h4>

                <form onSubmit={handleSubmit}>
                  {/* Display error message if exists */}
                  {error && (<div className="alert alert-danger" role="alert">{error}</div>)}

                  {/* User Id input fields */}
                  <div className="form-group text-left">
                    <label>User Id</label>
                    <input
                      type="text"
                      className="form-control"
                      value={userId}
                      onChange={(e) => { setUserId(e.target.value); setError(''); }}
                      required
                    />
                  </div>

                  {/* Password input fields */}
                  <div className="form-group text-left position-relative">
                    <label>Password</label>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control pr-5"
                      value={password}
                      onChange={(e) => { setPassword(e.target.value); setError(''); }}
                      required
                    />
                    <span
                      onClick={() => setShowPassword(prev => !prev)}
                      style={{
                        position: 'absolute',
                        right: '15px',
                        top: '45px',
                        cursor: 'pointer',
                        color: '#aaa'
                      }}
                    >
                      {showPassword ? '🔑' : '👁️'}
                    </span>
                  </div>

                  {/* Submit button */}
                  <button type="submit" className="btn btn-main mt-3">Login</button>
                </form>

                {/* Registration link */}
                <p className="text-muted mt-4">
                  Don’t have access yet? <Link to="/contact">Register here</Link>.
                </p>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
